import React from "react";
import ScreenSaver from "../../pages/ScreenSaver/ScreenSaver";
import ImgSrcGenerator from "./ImgSrcGenerator";

/**
 * Shop identification using query param.
 */
const SHOP_ID_PARAM_NAME = "shop";
const DEFAULT_SHOP_ID = 0;

/**
 * Slideshow behaviour.
 */
const INIT_IMG_ID = 1;
const NUMBER_OF_SLIDES = 3;
const TIMEOUT_IN_MILLIS = 30 * 1000;

/**
 * Url templates for background images.
 *
 * Format for shop number should be at least as long as the highest value for shop id.
 */
const SHOP_NUMBER_PLACEHOLDER = "%shop-number%";
const SLIDE_NUMBER_PLACEHOLDER = "%slide-number%";
const SHOP_NUMBER_FORMAT = "0".repeat(7);
const BUCKET_URL =
    "https://excite-tipico-retail.s3-eu-west-1.amazonaws.com/OUT";
const IMG_URL_TEMPLATE = `${BUCKET_URL}/hd_background_${SHOP_NUMBER_PLACEHOLDER}_${SLIDE_NUMBER_PLACEHOLDER}.jpg`;
const FALLBACK_IMG_URL_TEMPLATE = `${BUCKET_URL}/hd_background_${SHOP_NUMBER_FORMAT}_${SLIDE_NUMBER_PLACEHOLDER}.jpg`;

/**
 * Container responsible for setting up ScreenSaver with required fields.
 */
function ScreenSaverContainer() {
    const shopId = getShopIdParam();
    const imgSrcGenerator = new ImgSrcGenerator(
        IMG_URL_TEMPLATE,
        FALLBACK_IMG_URL_TEMPLATE,
        SHOP_NUMBER_PLACEHOLDER,
        SLIDE_NUMBER_PLACEHOLDER,
        SHOP_NUMBER_FORMAT
    );

    return (
        <ScreenSaver
            shopId={shopId}
            initImgId={INIT_IMG_ID}
            numberOfSlides={NUMBER_OF_SLIDES}
            timeoutInMillis={TIMEOUT_IN_MILLIS}
            imgSrcGenerator={imgSrcGenerator}
        />
    );
}

/**
 * Gets shop id from search param in url or returns default value.
 *
 * @return shop id as number or default value
 */
function getShopIdParam() {
    const searchParams = new URLSearchParams(window.location.search);
    const shopIdString = searchParams.get(SHOP_ID_PARAM_NAME);
    return shopIdString ? parseInt(shopIdString, 10) : DEFAULT_SHOP_ID;
}

export default ScreenSaverContainer;
